export const mutations = {
    setContext(state, context){
        state.context = context;
    },
    setAvail(state, avail){
        state.avail = avail;
    },
    setOptions(state, options){
        state.options = options;
    }
};